const countCharacters = function(string, maxNumeric) {
  let i, nonNumberCount;
  if (maxNumeric == null) { maxNumeric = string.length; }
  let numberCount = (nonNumberCount = (i = 0));
  while ((numberCount < maxNumeric) && (i < string.length)) {
    if (((string[i] >= '0') && (string[i] <= '9')) || (string[i] === '.')) {
      numberCount++;
    } else {
      nonNumberCount++;
    }
    i++;
  }
  return nonNumberCount;
};

angular.module('wbDirectives').directive('wbNumberField', ['$filter', $filter => ({
  require: '?ngModel',
  replace: false,
  restrict: 'A',

  scope: {
    min: '@',
    max: '@'
  },

  link($scope, element, attrs, ctrl){
    let suffix;
    const innerSetViewValue = ctrl.$setViewValue;
    const innerRender = ctrl.$render;
    let lastKeyPressed = null;
    let modifierPressed = false;
    let prefix = (suffix = '');
    let multiple = 1;

    switch (attrs.wbNumberField) {
      case 'percent' || 'percentage':
        suffix = '%';
        multiple = 100;
        break;
      case 'currency':
        prefix = '$';
        break;
    }

    element.attr('type', 'text');

    element.on('focus', function() {
      if (+ctrl.$modelValue !== 0) { return; }
      return element.val('');
    });

    ctrl.$setViewValue = function(value) {
      const trailingDecimalZeros = __guard__(value.replace(suffix,'').match(/\.0*$/g), x => x[0]) ||
        __guard__(value.match(/\.[1-9][0-9]*?(0+)$/), x1 => x1[1]) || '';
      let cleanValue = cleanString(value);

      // Output a blank string instead of undefined
      if (isNaN(cleanValue) || (cleanValue === '')) {
        element[0].value = '';
        return innerSetViewValue.apply(ctrl, ['']);
      }

      if (['percent', 'percentage'].includes(attrs.wbNumberField)) {
        cleanValue = cleanValue / multiple;
      }

      return innerSetViewValue.apply(ctrl, [cleanValue]);
    };

    /* Return the cursor position after having compensated for currency formatting */
    const getNewSelectionPosition = function(currentPosition, oldValue, newValue) {
      const previousNonNumericCount = countCharacters(oldValue.substr(0, currentPosition));
      const newNonNumericCount = countCharacters(newValue, currentPosition - previousNonNumericCount);
      let newPosition = (currentPosition + newNonNumericCount) - previousNonNumericCount;

      if (newPosition === 0) { newPosition += prefix.length; }
      if ((newValue !== undefined) && (newPosition >= newValue.length)) {
        newPosition = newValue.length - suffix.length;
      }
      return newPosition;
    };

    /* Remove any extra formatting and bring back to a bare, unformatted value */
    var cleanString = function(value) {
      if (!value) { return undefined; }
      // Clean symbols and commas
      return numeral(value.replace(suffix,'')).value().toString();
    };

    const currencyFormatter = function(value, trailingDecimal) {
      // No value, no output
      if (trailingDecimal == null) { trailingDecimal = ''; }
      if (isNaN(value) || (value === '')) { return ''; }

      // Skip this if the number starts with a zero but isn't a decimal
      if (!/^[0,]{1,}[0-9]+/.test(value)) {

        let format, places;
        if (attrs.places > 1) {
          places = Array(attrs.places + 1).join('0');
          format = '0,0.' + places;
          value = numeral(value * multiple).format(format);
        } else if (+attrs.places === 0) {
          value = numeral(value * multiple).format('0,0');
        } else {
          value = numeral(value * multiple).format('0,0.00');
        }
      }

      if (['percent', 'percentage'].includes(attrs.wbNumberField)) {
        trailingDecimal = '';
      }

      if (numeral.language() === 'fr-CA') {
        return value + trailingDecimal + suffix + " " + prefix;
      } else {
        return prefix + value + trailingDecimal + suffix;
      }
    };

    // Clean up formatting when we blur the field
    element.on('blur', event => element.val(currencyFormatter(ctrl.$viewValue)));

    ctrl.$render = function() {
      const viewValue  = ctrl.$isEmpty(ctrl.$modelValue) ? '' : ctrl.$viewValue;
      return element.val(currencyFormatter(viewValue));
    };

    ctrl.$formatters.push(value => parseFloat(value));

    /* Reset modifierPressed when modifier keys are unpressed */
    element.on('keyup', function(event) {
      const allowedModifierKeys = [91, 17];

      if (Array.from(allowedModifierKeys).includes(event.keyCode)) {
        return modifierPressed = false;
      }
    }); // reset modifier

    /* Handle the keystroke events in the input box */
    return element.on('keydown', function(event) {
      let value;
      lastKeyPressed = event.key;

      const numberKeys = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9' ];

      const allowedKeys = [ ...numberKeys,
                        'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
                       'Backspace', 'Delete', 'Home', 'End',
                       'Control', 'Meta', 'c', 'v', 'x', 'z', 'a',
                       'Tab', ',', 'Enter', '-', '.' ];

      // Cancel out inputs that are not numbers from 0 to 9 and who are space bar (32)
      if (!allowedKeys.includes(lastKeyPressed)) {
        event.preventDefault();
      }

      // Make entry on zero replace the value as opposed to add to zero
      if (numberKeys.includes(lastKeyPressed) && (this.value === (prefix + '0' + suffix))) {
        ctrl.$setViewValue('');
      }

      let start = this.selectionStart;
      const end = this.selectionEnd;

      // Delete the number to the left of the comma when pressing backspace on a comma
      switch (lastKeyPressed) {
        case 'Backspace':
          if (start === end) {
            const previousChar = this.value.substr( start - 1, 1 );
            // Ignore deleting over the prefix character
            if ((prefix != null) && (previousChar === prefix)) {
              return event.preventDefault();
            }
          }
          break;

        // Delete the number to the right of the comma when pressing delete on a comma
        case 'Delete':
          start = this.selectionStart;
          var nextChar = this.value.substr( start , 1 );
          if (nextChar === ',') {
            ({
              value
            } = this);

            // Remove the comma and the value before it
            const newValue = value.slice(0,start+1) + value.slice(start+2, value.length+1);
            return ctrl.$setViewValue(newValue);
          }
          break;

        // Modifier keys, Ctrl/Cmd-A (Select All)
        case 'a':
          if (modifierPressed) {
            return this.setSelectionRange(0, this.value.length);
          }
          break;

        // Prevent input of cut-copy-paste-undo characters when the modifier hasn't been pressed
        case 'c':
             case 'v':
             case 'x':
             case 'z':
          if (!modifierPressed) {
            return event.preventDefault();
          }
          break;
        case 'Meta': // Cmd
             case 'Control':
          return modifierPressed = true;

        case '.':
          if (/[.]/.test(element[0].value)) { // Block out any extra period
            return event.preventDefault();
          }
          break;

        case 'Enter':
          return $scope.model || ($scope.model = Number($scope.min) || 0);
      }
    });
  }
})
]);

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}
